/** @jsx jsx */
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Flex, jsx, Text } from 'theme-ui'
import { useAnalytics } from '@chordcommerce/gatsby-theme-autonomy'
import LineItemGiftCards from './GiftCards'
import QuantitySelector from '~/components/Cart/QuantitySelector'
import { useCartFlyout } from '~/hooks/components/use-cart-flyout'
import { useAddToCart } from '~/hooks/components/use-add-to-cart'

const LineItem = ({ lineItem, linkProduct = true, orderConfirmed = false }) => {
  const {
    giftCards,
    id,
    quantity,
    singleDisplayAmount,
    subscriptionLineItems,
    variant,
  } = lineItem
  const { name, sku, slug } = variant

  const { getAddToCartDataBySku } = useAddToCart()
  const { trackProductClicked } = useAnalytics()
  const { closeCartFlyout } = useCartFlyout()

  const { image, listingSlug } = getAddToCartDataBySku(sku) || {}

  const handleClickProduct = () => {
    closeCartFlyout()
    trackProductClicked({ product: lineItem })
  }

  return (
    <Flex>
      {image && (
        <Box mr={[1, 2]} sx={{ flexShrink: '0' }}>
          {linkProduct && (
            <Link
              to={`/products/${listingSlug || slug}/`}
              onClick={() => handleClickProduct()}
            >
              <LineItemImage image={image} />
            </Link>
          )}
          {!linkProduct && <LineItemImage image={image} />}
        </Box>
      )}
      <Box sx={{ flex: '1' }}>
        <Flex>
          <Box sx={{ flex: '1' }}>
            {linkProduct && (
              <Link
                onClick={() => handleClickProduct()}
                to={`/products/${listingSlug || slug}/`}
                sx={{
                  color: 'black',
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                <LineItemName name={name} />
              </Link>
            )}
            {!linkProduct && <LineItemName name={name} />}
          </Box>
          <Box ml={[2, 3]} sx={{ flexShrink: '0' }}>
            <Text as="p" variant="title6">
              {singleDisplayAmount}
            </Text>
          </Box>
        </Flex>
        {giftCards.length > 0 && (
          <LineItemGiftCards
            giftCards={giftCards}
            lineItemId={id}
            orderConfirmed={orderConfirmed}
          />
        )}
        <Box mt={2}>
          {orderConfirmed && (
            <Text as="p" variant="body2">
              QTY: {quantity}
            </Text>
          )}
          {!orderConfirmed && giftCards.length === 0 && (
            <QuantitySelector
              // Don't allow users to increase promo gift quantities.
              disableChange={
                singleDisplayAmount === '$0.00' ||
                !!subscriptionLineItems.length
              }
              quantity={quantity}
              lineItemId={id}
              sx={{
                marginRight: ['0', null, '4px'],
                width: ['96px', '128px'],
              }}
            />
          )}
        </Box>
      </Box>
    </Flex>
  )
}

const LineItemImage = ({ image }) => {
  return (
    <GatsbyImage
      image={image.gatsbyImageData}
      alt={image.description}
      sx={{
        height: 'auto',
        width: ['80px', '88px'],
      }}
    />
  )
}

const LineItemName = ({ name }) => {
  return (
    <Text as="p" variant="title6" mb="2px">
      {name}
    </Text>
  )
}

export default LineItem
